module.exports = __webpack_public_path__ + "static/media/web logos_NSO.90831f09.jpg";